import { render, staticRenderFns } from "./FinalAllocationList.vue?vue&type=template&id=54f35b94"
import script from "./FinalAllocationList.vue?vue&type=script&lang=js"
export * from "./FinalAllocationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports